const deleteFrequency = {
  toastr: 'Periodicidad eliminada',
  toastr1: 'eliminada con éxito'
};

export default deleteFrequency;
